import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 26,
	viewBox: "0 0 25 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 13,
			r: 12,
			stroke: "#003B6F"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_13741_27019)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M15.4494 18.8329C14.6315 18.8055 14.0146 18.6001 13.416 18.317C12.4473 17.8603 11.5882 17.2302 10.7886 16.527C9.70105 15.5681 8.73689 14.5042 7.92809 13.2987C7.462 12.6001 7.05989 11.8695 6.82228 11.0612C6.66692 10.527 6.60294 9.98362 6.75374 9.43111C6.84056 9.11147 7.00963 8.84206 7.24267 8.60919C7.71333 8.14343 8.17941 7.67311 8.6455 7.20279C8.70033 7.148 8.72318 7.15713 8.77344 7.20736C9.7376 8.1754 10.7063 9.13887 11.6751 10.1023C11.7345 10.1617 11.7253 10.1891 11.6705 10.2393C11.145 10.7644 10.6195 11.2896 10.094 11.8101C10.0438 11.8603 10.03 11.8923 10.0803 11.9562C11.0719 13.2667 12.1823 14.4631 13.5531 15.39C13.6217 15.4357 13.6536 15.4357 13.713 15.3763C14.2248 14.8558 14.7457 14.3398 15.2575 13.8192C15.3215 13.7553 15.3535 13.7553 15.4129 13.8192C16.3679 14.7781 17.3275 15.737 18.2871 16.6914C18.3465 16.7507 18.3556 16.7827 18.2917 16.8466C17.8438 17.285 17.396 17.7279 16.9574 18.18C16.4958 18.6549 15.9384 18.8421 15.4494 18.8329Z",
				fill: "#003B6F"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_13741_27019",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 11.6659,
				height: 11.6667,
				fill: "white",
				transform: "translate(6.66602 7.1665)"
			})
		}) })
	]
});
export default SvgPhone;
